import React, { useEffect, useState } from 'react';
import { TabsTimelineSub } from 'components';
import { tabs } from './tabs';
import { useSelector } from 'react-redux';
import { useSupplierType } from 'hooks/useSupplierType';

const BasicInfoSupplier = () => {
  const currentSubTab = useSelector(state => state.forms.carrier.currentSubTab) || 0;
  const { isDirectSupplier, isIndirectSupplier } = useSupplierType()
  return (
    <TabsTimelineSub
      tabs={tabs({ isDirectSupplier, isIndirectSupplier })}
      // current={'0'} 
      // setCurrent={'0'} 
      currentSubTab={currentSubTab} 
      customClass={'custom-tabs-timeline-sub'}
    />
  );
};

export default BasicInfoSupplier;